import { z } from 'zod';

export enum ToolTypeEnum {
  APIServer = 1,
};
export const toolTypeSchema = z.enum(ToolTypeEnum);
export type ToolType = z.infer<typeof toolTypeSchema>;

export const getToolTypeName = (typeId: ToolTypeEnum) => {
  return {
    [ToolTypeEnum.APIServer]: 'API Server',
  }[typeId] ?? 'Unknown';
};